import React, { useEffect, useState, useRef } from "react";
import api from "./api";
import { createPortal } from "react-dom";
import { useMsal } from "@azure/msal-react";
const ROLE_COLORS = {
  Admin:      { bg: '#166534', text: '#fff'    },
  Supervisor: { bg: '#af401e', text: '#fff'    }, // was #dbeafe — much more distinct
  Verifier:   { bg: '#6d28d9', text: '#fff'    }, // was #ede9fe — much more distinct
  User:       { bg: '#374151', text: '#fff'    }, // was #f3f4f6 — visible as a dot
};
function CredSection({ icon, title, desc, children }) {
  return (
    <div style={{
      padding: '20px 0', borderBottom: '1px solid #f0f0f0',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
        <div style={{
          width: 30, height: 30, borderRadius: 8, background: '#f3f4f6',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          <i className={`ti ${icon}`} style={{ fontSize: 15, color: '#555' }} aria-hidden="true" />
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#111' }}>{title}</div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 1 }}>{desc}</div>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>{children}</div>
    </div>
  );
}

function SecretField({ label, value, onChange }) {
  return (
    <div>
      <label style={s.label}>{label}</label>
      <input
        style={s.input}
        type="password"
        value={value}
        placeholder="Leave blank to keep existing"
        onChange={e => onChange(e.target.value)}
        autoComplete="new-password"  // prevents browser autofill from revealing it
      />
    </div>
  );
}
function RoleDropdown({ role, onRoleChange, onDelete }) {
  const [open, setOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0, width: 0 });
  const [toast, setToast] = useState(null); // ← add this
  const btnRef = useRef(null);
  const roles = ['User', 'Supervisor', 'Verifier', 'Admin'];

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (!btnRef.current?.contains(e.target) && !document.getElementById('role-dropdown-portal')?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('pointerdown', handler);
    return () => document.removeEventListener('pointerdown', handler);
  }, [open]);

  const handleOpen = () => {
    const rect = btnRef.current.getBoundingClientRect();
    setMenuPos({ top: rect.bottom + 6, left: rect.right - 150, width: 150 });
    setOpen(o => !o);
  };

  const handleRoleSelect = (r) => {       // ← new handler
    onRoleChange(r);
    setOpen(false);
    setToast(r);
    setTimeout(() => setToast(null), 2000);
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {toast && (                         // ← toast element
          <span style={{
            fontSize: 12, color: '#16a34a', fontWeight: 600,
            display: 'flex', alignItems: 'center', gap: 4,
            animation: 'fadeInOut 2s ease forwards',
          }}>
            ✓ Set to {toast}
          </span>
        )}
<button
  ref={btnRef}
  onClick={handleOpen}
  style={{
    padding: '5px 12px', borderRadius: 20, fontSize: 13, cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: 6, fontWeight: 500,
    border: 'none',
    background: ROLE_COLORS[role]?.bg,
    color: ROLE_COLORS[role]?.text,
  }}
>
  {role} <span style={{ fontSize: 10, opacity: 0.6 }}>▾</span>
</button>
      </div>

      {open && createPortal(
        <div
          id="role-dropdown-portal"
          style={{ position: 'fixed', top: menuPos.top, left: menuPos.left, minWidth: menuPos.width,
            background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8,
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)', zIndex: 9999, overflow: 'hidden' }}
        >
          {roles.map(r => (
            <div key={r} onClick={() => handleRoleSelect(r)}   // ← use new handler
              style={{ padding: '9px 14px', fontSize: 13, cursor: 'pointer',
                fontWeight: r === role ? 600 : 400, color: r === role ? '#0078d4' : '#111' }}
              onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
              onMouseLeave={e => e.currentTarget.style.background = ''}
            >
              {r === role ? '✓ ' : ''}{r}
            </div>
          ))}
          <div style={{ height: 1, background: '#e5e7eb', margin: '4px 0' }} />
          <div onClick={() => { setOpen(false); onDelete(); }}
            style={{ padding: '9px 14px', fontSize: 13, cursor: 'pointer', color: '#dc2626', fontWeight: 500 }}
            onMouseEnter={e => e.currentTarget.style.background = '#fef2f2'}
            onMouseLeave={e => e.currentTarget.style.background = ''}
          >
            🗑 Delete user
          </div>
        </div>,
        document.body
      )}

      <style>{`@keyframes fadeInOut { 0%{opacity:0} 10%{opacity:1} 80%{opacity:1} 100%{opacity:0} }`}</style>
    </>
  );
}
function AdminPanel({ currentUserEmail, onClose, onPdfEmailChange, onLogout }) {
  const authProvider = localStorage.getItem("authProvider") || "microsoft";
  const isGoogle = authProvider === "google";
const [pdfResolution, setPdfResolution] = useState('medium');
const [savingResolution, setSavingResolution] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("users");
  const [savingCreds, setSavingCreds] = useState(false);
  const [newUserName, setNewUserName] = useState("");
  const [newUserEmail, setNewUserEmail] = useState("");
const [maxPhotosPerItem, setMaxPhotosPerItem] = useState(4);
const [reportUrl, setReportUrl] = useState("");
const [savingMaxPhotos, setSavingMaxPhotos] = useState(false);
const [pdfDestinations, setPdfDestinations] = useState(['email', 'sharepoint', 'striven', 'local']);
const [savingDestinations, setSavingDestinations] = useState(false);
  // Credentials state
  const [orgName, setOrgName] = useState("");
  const [pdfEmail, setPdfEmail] = useState("");
  const [strivenClientId, setStrivenClientId] = useState("");
  const [strivenClientSecret, setStrivenClientSecret] = useState("");
  const [azureClientId, setAzureClientId] = useState("");
  const [azureClientSecret, setAzureClientSecret] = useState("");
  const [azureTenantId, setAzureTenantId] = useState("");
  const [sharepointSiteId, setSharepointSiteId] = useState("");
  const [googleClientId, setGoogleClientId] = useState("");
  const [googleAppName, setGoogleAppName] = useState("");
  const [googleDriveFolderId, setGoogleDriveFolderId] = useState("");

  // Settings state
const [requireItemPhotos, setRequireItemPhotos] = useState(true);
const [requireOrderPhoto, setRequireOrderPhoto] = useState(true);
const [togglingItemPhotos, setTogglingItemPhotos] = useState(false);
const [togglingOrderPhoto, setTogglingOrderPhoto] = useState(false);

  const { instance, accounts } = useMsal();
  const account = isGoogle ? null : accounts?.[0];
  const msalInstance = isGoogle ? null : instance;
const [setLabel, setSetLabel] = useState('Carton');
const [savingLabel, setSavingLabel] = useState(false);
const [showWarehouseLocation, setShowWarehouseLocation] = useState(true);
const [togglingWarehouseLocation, setTogglingWarehouseLocation] = useState(false);
const [strivenSyncEnabled, setStrivenSyncEnabled] = useState(true);
const [togglingStrivenSync, setTogglingStrivenSync] = useState(false);
  const getAdminHeaders = async () => {
    if (isGoogle) {
      const token = localStorage.getItem("authToken");
      return { Authorization: `Bearer ${token}` };
    }
    const configRes = await api.get("/api/config/azure");
    const { clientId } = configRes.data;
    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: [`api://${clientId}/access_as_user`],
      account,
    });
    return { Authorization: `Bearer ${tokenResponse.accessToken}` };
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const headers = await getAdminHeaders();
        const res = await api.get("/api/users/all", { headers });
        setUsers(res.data);
      } catch (err) {
        console.error("Failed to fetch users:", err);
        alert("Failed to fetch users.");
      } finally {
        setLoading(false);
      }
    };
    if (isGoogle || account) fetchUsers();
  }, [account]);

  useEffect(() => {
    const fetchCredentials = async () => {
      try {
        const headers = await getAdminHeaders();
        const res = await api.get("/api/config/credentials", { headers });
        const c = res.data;
        setOrgName(c.orgName || "");
        setPdfEmail(c.pdfEmail || "");
        setStrivenClientId(c.strivenClientId || "");
        setStrivenClientSecret(c.strivenClientSecret || "");
        setAzureClientId(c.azureClientId || "");
        setAzureClientSecret(c.azureClientSecret || "");
        setAzureTenantId(c.azureTenantId || "");
        setSharepointSiteId(c.sharepointSiteId || "");
        setGoogleClientId(c.googleClientId || "");
        setGoogleAppName(c.googleAppName || "");
        setGoogleDriveFolderId(c.googleDriveFolderId || "");
        setRequireItemPhotos(c.requireItemPhotos ?? true);
setRequireOrderPhoto(c.requireOrderPhoto ?? true);
        setSetLabel(c.setLabel ?? 'Carton');
        setMaxPhotosPerItem(c.maxPhotosPerItem ?? 4);
        setPdfResolution(c.pdfResolution ?? 'medium');
        setPdfDestinations(c.pdfDestinations ?? ['email', 'sharepoint', 'striven', 'local']);
        setReportUrl(c.reportUrl || "");
        setShowWarehouseLocation(c.showWarehouseLocation ?? true);
        setStrivenSyncEnabled(c.strivenSyncEnabled ?? true);
      } catch (err) {
        console.error("Failed to fetch credentials:", err);
      }
    };
    if (isGoogle || account) fetchCredentials();
  }, [account]);

const handleToggleItemPhotos = async () => {
  const next = !requireItemPhotos;
  setTogglingItemPhotos(true);
  try {
    const headers = await getAdminHeaders();
    await api.post("/api/admin/settings/require-photos", { requireItemPhotos: next }, { headers });
    setRequireItemPhotos(next);
  } catch {
    alert("Failed to update item photo setting.");
  } finally {
    setTogglingItemPhotos(false);
  }
};
const handleSaveDestinations = async () => {
  setSavingDestinations(true);
  try {
    const headers = await getAdminHeaders();
    await api.post('/api/admin/settings/pdf-destinations', { pdfDestinations }, { headers });
    alert('PDF destinations saved.');
  } catch {
    alert('Failed to save PDF destinations.');
  } finally {
    setSavingDestinations(false);
  }
};
const handleSavePdfResolution = async () => {
  setSavingResolution(true);
  try {
    const headers = await getAdminHeaders();
    await api.post('/api/admin/settings/pdf-resolution', { pdfResolution }, { headers });
    alert('PDF resolution saved.');
  } catch {
    alert('Failed to save PDF resolution.');
  } finally {
    setSavingResolution(false);
  }
};
const handleToggleOrderPhoto = async () => {
  const next = !requireOrderPhoto;
  setTogglingOrderPhoto(true);
  try {
    const headers = await getAdminHeaders();
    await api.post("/api/admin/settings/require-photos", { requireOrderPhoto: next }, { headers });
    setRequireOrderPhoto(next);
  } catch {
    alert("Failed to update order photo setting.");
  } finally {
    setTogglingOrderPhoto(false);
  }
};
const handleSaveSetLabel = async () => {
  setSavingLabel(true);
  try {
    const headers = await getAdminHeaders();
    await api.post('/api/admin/settings/set-label', { setLabel }, { headers });
    alert('Box type saved.');
  } catch (err) {
    alert('Failed to save box type.');
  } finally {
    setSavingLabel(false);
  }
};
const handleToggleWarehouseLocation = async () => {
  const next = !showWarehouseLocation;
  setTogglingWarehouseLocation(true);
  try {
    const headers = await getAdminHeaders();
    await api.post("/api/admin/settings/warehouse-location", 
      { showWarehouseLocation: next }, { headers });
    setShowWarehouseLocation(next);
  } catch {
    alert("Failed to update warehouse location setting.");
  } finally {
    setTogglingWarehouseLocation(false);
  }
};
const handleToggleStrivenSync = async () => {
  const next = !strivenSyncEnabled;
  if (!next && !window.confirm(
    "Turn off Striven sync?\n\nVerifying will still create, upload and email the PDF, but nothing will be marked in Striven. " +
    "Orders verified while this is off must be updated in Striven by hand, and 2Check won't know they were already verified."
  )) return;
  setTogglingStrivenSync(true);
  try {
    const headers = await getAdminHeaders();
    await api.post("/api/admin/settings/striven-sync", { enabled: next }, { headers });
    setStrivenSyncEnabled(next);
  } catch {
    alert("Failed to update the Striven sync setting.");
  } finally {
    setTogglingStrivenSync(false);
  }
};
  const handleSaveCredentials = async () => {
    if (!strivenClientId || !strivenClientSecret)
      return alert("Striven credentials are required.");
    if (!isGoogle && (!azureClientId || !azureClientSecret || !azureTenantId))
      return alert("Azure credentials are required.");
    if (isGoogle && (!googleClientId || !googleDriveFolderId || !googleAppName))
      return alert("Google credentials are required.");

    setSavingCreds(true);
    try {
      const headers = await getAdminHeaders();
await api.post("/api/admin/credentials", {
  orgName, authProvider, pdfEmail,
  strivenClientId, strivenClientSecret,
  azureClientId, azureClientSecret, azureTenantId, sharepointSiteId,
  googleClientId, googleAppName, googleDriveFolderId,
  reportUrl,
}, { headers });
      alert("Credentials saved successfully.");
    } catch (err) {
      console.error("Failed to save credentials:", err);
      const data = err.response?.data;
      alert(typeof data === "object" && data?.error ? data.error : "Failed to save credentials.");
    } finally {
      setSavingCreds(false);
    }
  };

const handleReconnectGoogle = async () => {
  localStorage.setItem("adminReconnectingGoogle", "true");

  const { data } = await api.get("/api/setup/google-auth-url", {
    headers: await getAdminHeaders()
  });
  window.location.href = data.url;
};
const handleSaveMaxPhotos = async () => {
  setSavingMaxPhotos(true);
  try {
    const headers = await getAdminHeaders();
    await api.post('/api/admin/settings/max-photos', { maxPhotosPerItem }, { headers });
    alert('Max photos saved.');
  } catch {
    alert('Failed to save max photos setting.');
  } finally {
    setSavingMaxPhotos(false);
  }
};
  const handleAddUser = async () => {
    if (!newUserName || !newUserEmail) return alert("Please fill in both Name and Email.");
    try {
      const headers = await getAdminHeaders();
      const res = await api.post("/api/users/add",
        { name: newUserName, email: newUserEmail }, { headers });
      setUsers(prev => [...prev, res.data]);
      setNewUserName("");
      setNewUserEmail("");
    } catch (err) {
      if (err.response?.status === 402) {
        alert(err.response?.data?.detail || "User limit reached for this plan.");
      } else {
        alert(err.response?.data || "Failed to add user.");
      }
    }
  };

  const handleDeleteUser = async (email) => {
    if (!window.confirm(`Delete ${email}?`)) return;
    try {
      const headers = await getAdminHeaders();
      await api.post("/api/users/delete", { email }, { headers });
      setUsers(prev => prev.filter(u => u.email !== email));
    } catch (err) {
      alert("Failed to delete user.");
    }
  };
// Add handler alongside handleRoleChange:
const handlePoAccessToggle = async (email, current) => {
  try {
    const headers = await getAdminHeaders();
    await api.post("/api/users/toggle-po-access", { email, poReceivingAccess: !current }, { headers });
    setUsers(prev => prev.map(u => u.email === email ? { ...u, poReceivingAccess: !current } : u));
  } catch {
    alert("Failed to update PO receiving access.");
  }
};
  const handleRoleChange = async (email, newRole) => {
    if (email === currentUserEmail) return alert("You cannot change your own role.");
    try {
      const headers = await getAdminHeaders();
      await api.post("/api/users/change-role", { email, newRole }, { headers });
      setUsers(prev => prev.map(u => u.email === email ? { ...u, role: newRole } : u));
    } catch (err) {
      alert("Failed to update role.");
    }
  };

  return (
    <div style={s.overlay}>
      <div style={s.panel}>

        {/* Header */}
        <div style={s.header}>
          <h2 style={s.headerTitle}>Admin Panel</h2>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button style={s.logoutBtn} onClick={onLogout}>Sign Out</button>
            <button style={s.closeBtn} onClick={onClose}>✕</button>
          </div>
        </div>

        {/* Tabs */}
        <div style={s.tabs}>
          {["users", "credentials", "settings"].map(tab => (
            <button key={tab} style={{ ...s.tab, ...(activeTab === tab ? s.tabActive : {}) }}
              onClick={() => setActiveTab(tab)}>
              {tab === "users" ? "👥 Users" : tab === "credentials" ? "🔑 Credentials" : "⚙️ Settings"}
            </button>
          ))}
        </div>

        <div style={s.body}>

          {/* ── USERS TAB ── */}
 {activeTab === "users" && (
  <div>
    <div style={s.addUserRow}>
      <input style={s.input} placeholder="Name"
        value={newUserName} onChange={e => setNewUserName(e.target.value)} />
      <input style={s.input} placeholder="Email"
        value={newUserEmail} onChange={e => setNewUserEmail(e.target.value)} />
      <button style={s.addBtn} onClick={handleAddUser}>Add User</button>
    </div>
{/* Summary bar — add this right after the add-user row, before the users list */}
{!loading && (() => {
  const counts = {
    total: users.length,
    Admin: users.filter(u => u.role === 'Admin').length,
    Supervisor: users.filter(u => u.role === 'Supervisor').length,
    Verifier: users.filter(u => u.role === 'Verifier').length,
    User: users.filter(u => u.role === 'User').length,
  };
  const stats = [
    { label: 'Total',       value: counts.total,      dot: '#555'    },
{ label: 'Admins',      value: counts.Admin,      dot: ROLE_COLORS.Admin.bg      },
{ label: 'Supervisors', value: counts.Supervisor,  dot: ROLE_COLORS.Supervisor.bg },
{ label: 'Verifiers',   value: counts.Verifier,    dot: ROLE_COLORS.Verifier.bg   },
{ label: 'Users',       value: counts.User,        dot: ROLE_COLORS.User.bg       },
  ];
  return (
    <div style={{
      display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)',
      gap: 1, background: '#e5e7eb',
      borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb',
      marginBottom: 8,
    }}>
      {stats.map(({ label, value, dot }) => (
        <div key={label} style={{ background: '#f9fafb', padding: '10px 14px' }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: '#111' }}>{value}</div>
          <div style={{ fontSize: 10, color: '#888', marginTop: 2, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: dot, display: 'inline-block', marginRight: 5, verticalAlign: 1 }} />
            {label}
          </div>
        </div>
      ))}
    </div>
  );
})()}
 {loading ? <div style={{ padding: 20, color: "#888" }}>Loading users…</div> : (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

{/* Column header — OUTSIDE the map */}
<div style={{
  display: 'flex', alignItems: 'center', gap: 14,
  padding: '4px 16px', fontSize: 11, fontWeight: 600,
  color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em'
}}>
  <div style={{ width: 40, flexShrink: 0 }} />
  <div style={{ flex: 1 }}>User</div>
  <div style={{ width: 110, textAlign: 'center', flexShrink: 0 }}>PO Receiving</div>
  <div style={{ width: 130, textAlign: 'center', flexShrink: 0 }}>Role</div>
</div>

    {users.map(u => (
      <div key={u.email} style={s.userRow}>
        {/* Avatar */}
        <div style={{
          ...s.avatar,
          background: ROLE_COLORS[u.role]?.bg,
          color: ROLE_COLORS[u.role]?.text,
        }}>
          {u.name?.charAt(0).toUpperCase()}
        </div>

        {/* Name + email */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#111' }}>{u.name}</div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{u.email}</div>
        </div>

        {/* PO Receiving toggle */}
{u.email !== currentUserEmail ? (
  <div style={{ width: 110, display: 'flex', justifyContent: 'center' }}>
    <button
      onClick={() => handlePoAccessToggle(u.email, u.poReceivingAccess)}
      title="Toggle PO Receiving access"
      style={{
        padding: '4px 12px', borderRadius: 20, border: 'none',
        cursor: 'pointer', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap',
        background: u.poReceivingAccess ? '#dbeafe' : '#f3f4f6',
        color:      u.poReceivingAccess ? '#1d4ed8' : '#9ca3af',
      }}
    >
      {u.poReceivingAccess ? 'PO Access Granted' : 'No PO Access'}
    </button>
  </div>
) : (
  <div style={{ width: 110, textAlign: 'center', fontSize: 12, color: '#9ca3af' }}>
    {u.poReceivingAccess ? 'PO Access' : '—'}
  </div>
)}
{/* Role */}
{u.email === currentUserEmail ? (
  <div style={{ width: 130, display: 'flex', justifyContent: 'center' }}>
    <span style={{ ...s.rolePill, ...(u.role === 'Admin' ? s.rolePillAdmin : {}), textAlign: 'center', boxSizing: 'border-box' }}>
      {u.role === 'Admin' ? '★ ' : ''}{u.role} (you)
    </span>
  </div>
) : (
  <div style={{ width: 130, display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
    <RoleDropdown
      role={u.role}
      onRoleChange={role => handleRoleChange(u.email, role)}
      onDelete={() => handleDeleteUser(u.email)}
    />
  </div>
)}
      </div>
    ))}
  </div>
)}</div>
)}
          {/* ── CREDENTIALS TAB ── */}
{activeTab === "credentials" && (
  <div style={{ display: "flex", flexDirection: "column" }}>
    <div style={{
      background: '#fffbeb',
      border: '1px solid #f59e0b',
      borderRadius: 8,
      padding: '10px 14px',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      fontSize: 13,
      color: '#92400e',
      fontWeight: 500,
      marginBottom: 4,
    }}>
      <span style={{ fontSize: 18 }}>⚠️</span>
      <span>After saving any changes, <strong>refresh the page</strong> for them to take effect for all users.</span>
    </div>

    {/* Organization */}
    <CredSection icon="ti-building" title="Organization" desc="Basic info and delivery settings">
      <div style={s.grid2}>
        <Field label="Organization name" value={orgName} onChange={setOrgName} />
        <Field label="PDF delivery email" value={pdfEmail} onChange={setPdfEmail} type="email" />
      </div>
    </CredSection>
<CredSection icon="ti-report" title="PO Receiving Report" desc="Report URL used to look up purchase orders">
  <Field
    label="Report URL"
    value={reportUrl}
    onChange={setReportUrl}
    placeholder="https://app.striven.com/reports/..."
  />
</CredSection>
    {/* Striven */}
    <CredSection icon="ti-plug" title="Striven API" desc="Required for order sync">
      <div style={s.grid2}>
        <Field label="Client ID" value={strivenClientId} onChange={setStrivenClientId} />
        <SecretField label="Client secret" value={strivenClientSecret} onChange={setStrivenClientSecret} />
      </div>
    </CredSection>

    {/* Azure */}
    {!isGoogle && (
      <CredSection icon="ti-brand-azure" title="Azure / SharePoint" desc="For file storage and auth">
        <div style={{ ...s.grid2, marginBottom: 12 }}>
          <Field label="Client ID" value={azureClientId} onChange={setAzureClientId} />
          <SecretField label="Client secret" value={azureClientSecret} onChange={setAzureClientSecret} />
        </div>
        <div style={s.grid2}>
          <Field label="Tenant ID" value={azureTenantId} onChange={setAzureTenantId} />
          <Field label="SharePoint site ID" value={sharepointSiteId} onChange={setSharepointSiteId} />
        </div>
      </CredSection>
    )}

    {/* Google */}
    {isGoogle && (
      <CredSection icon="ti-brand-google" title="Google Workspace" desc="OAuth and Drive settings">
        <div style={s.grid2}>
          <Field label="OAuth client ID" value={googleClientId} onChange={setGoogleClientId} />
          <Field label="Application name" value={googleAppName} onChange={setGoogleAppName} />
        </div>
        <Field label="Drive folder ID" value={googleDriveFolderId} onChange={setGoogleDriveFolderId} />
        <div style={s.reconnectBox}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 13 }}>Google account connection</div>
            <div style={{ fontSize: 12, color: "#666", marginTop: 2 }}>
              Re-run OAuth if your refresh token expired or you want a different account.
            </div>
          </div>
          <button style={s.reconnectBtn} onClick={handleReconnectGoogle}>
            <GoogleIcon /> Reconnect
          </button>
        </div>
      </CredSection>
    )}

    <div style={{ padding: "16px 0 4px", display: "flex", justifyContent: "flex-end" }}>
      <button style={s.saveBtn} onClick={handleSaveCredentials} disabled={savingCreds}>
        {savingCreds ? "Saving…" : "Save credentials"}
      </button>
    </div>
  </div>
)}

          {/* ── SETTINGS TAB ── */}
          {activeTab === "settings" && (
  <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
    <div style={{
      background: '#fffbeb',
      border: '1px solid #f59e0b',
      borderRadius: 8,
      padding: '10px 14px',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      fontSize: 13,
      color: '#92400e',
      fontWeight: 500,
    }}>
      <span style={{ fontSize: 18 }}>⚠️</span>
      <span>After saving any changes, <strong>refresh the page</strong> for them to take effect for all users.</span>
    </div>
              <Section title="PDF Destinations">
  <div style={s.settingInfo}>
    <div style={s.settingDesc}>
      Choose where the generated PDF is sent when a user submits an order.
      At least one destination must be selected.
    </div>
  </div>

  {[
    { key: 'local',      label: 'Local download',          desc: 'PDF downloads directly to the user\'s device.' },
    { key: 'email',      label: 'Email',                   desc: 'PDF is emailed to the configured delivery address.' },
    { key: 'sharepoint', label: isGoogle ? 'Google Drive' : 'SharePoint', desc: isGoogle ? 'PDF is uploaded to your configured Drive folder.' : 'PDF is uploaded to your configured SharePoint site.' },
    { key: 'striven',    label: 'Striven attachment',      desc: 'PDF is attached directly to the order in Striven.' },
  ].map(({ key, label, desc }) => {
    const checked = pdfDestinations.includes(key);
    const isLast = pdfDestinations.length === 1 && checked; // prevent deselecting all
    return (
      <div key={key} style={{ ...s.settingRow, alignItems: 'flex-start', gap: 12, padding: '10px 0', borderBottom: '0.5px solid #e5e7eb' }}>
        <input
          type="checkbox"
          id={`dest-${key}`}
          checked={checked}
          disabled={isLast}
          onChange={() => {
            setPdfDestinations(prev =>
              checked ? prev.filter(d => d !== key) : [...prev, key]
            );
          }}
          style={{ marginTop: 3, cursor: isLast ? 'not-allowed' : 'pointer', width: 16, height: 16, flexShrink: 0 }}
        />
        <label htmlFor={`dest-${key}`} style={{ cursor: isLast ? 'not-allowed' : 'pointer', flex: 1 }}>
          <div style={{ ...s.settingLabel, fontSize: 13 }}>{label}</div>
          <div style={s.settingDesc}>{desc}</div>
        </label>
      </div>
    );
  })}

  <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 8 }}>
    <button
      onClick={handleSaveDestinations}
      disabled={savingDestinations || pdfDestinations.length === 0}
      style={{ ...s.addBtn, whiteSpace: 'nowrap' }}
    >
      {savingDestinations ? 'Saving…' : 'Save'}
    </button>
  </div>
</Section>
<Section title="Striven Sync">
  <div style={s.settingRow}>
    <div style={s.settingInfo}>
      <div style={s.settingLabel}>Update orders in Striven when verifying</div>
      <div style={s.settingDesc}>
        On: verifying marks the order verified in Striven, adds the internal note, and attaches the PDF.
        Off: the PDF is still created, uploaded and emailed, but Striven isn't touched. Use this when
        Striven is rejecting saves and orders still need to ship.
      </div>
    </div>
    <button
      type="button"
      disabled={togglingStrivenSync}
      onClick={handleToggleStrivenSync}
      style={{
        ...s.toggleBtn,
        background: strivenSyncEnabled ? "#16a34a" : "#d1d5db",
        color: strivenSyncEnabled ? "#fff" : "#374151",
        opacity: togglingStrivenSync ? 0.6 : 1,
      }}
    >
      {togglingStrivenSync ? "…" : strivenSyncEnabled ? "On" : "Off"}
    </button>
  </div>
</Section>
<Section title="Order Fields">
  <div style={s.settingRow}>
    <div style={s.settingInfo}>
      <div style={s.settingLabel}>Warehouse location</div>
      <div style={s.settingDesc}>
        Show the warehouse location field on PO receiving and order verification. 
        Disable if your Striven setup doesn't use warehouse locations.
      </div>
    </div>
    <button
      type="button"
      disabled={togglingWarehouseLocation}
      onClick={handleToggleWarehouseLocation}
      style={{
        ...s.toggleBtn,
        background: showWarehouseLocation ? "#16a34a" : "#d1d5db",
        color: showWarehouseLocation ? "#fff" : "#374151",
        opacity: togglingWarehouseLocation ? 0.6 : 1,
      }}
    >
      {togglingWarehouseLocation ? "…" : showWarehouseLocation ? "Visible" : "Hidden"}
    </button>
  </div>
</Section>
 <Section title="Photo Requirements">
  <div style={s.settingRow}>
    <div style={s.settingInfo}>
      <div style={s.settingLabel}>Require item photos</div>
      <div style={s.settingDesc}>
        Users must photograph each individual item before submitting.
      </div>
    </div>
    <button
      type="button"
      disabled={togglingItemPhotos}
      onClick={handleToggleItemPhotos}
      style={{
        ...s.toggleBtn,
        background: requireItemPhotos ? "#16a34a" : "#d1d5db",
        color: requireItemPhotos ? "#fff" : "#374151",
        opacity: togglingItemPhotos ? 0.6 : 1,
      }}
    >
      {togglingItemPhotos ? "…" : requireItemPhotos ? "Mandatory" : "Optional"}
    </button>
  </div>

  <div style={{ borderTop: "1px solid #e5e7eb", margin: "12px 0" }} />

  <div style={s.settingRow}>
    <div style={s.settingInfo}>
      <div style={s.settingLabel}>Require full order photo</div>
      <div style={s.settingDesc}>
        Users must photograph the completed order as a whole before submitting.
      </div>
    </div>
    <button
      type="button"
      disabled={togglingOrderPhoto}
      onClick={handleToggleOrderPhoto}
      style={{
        ...s.toggleBtn,
        background: requireOrderPhoto ? "#16a34a" : "#d1d5db",
        color: requireOrderPhoto ? "#fff" : "#374151",
        opacity: togglingOrderPhoto ? 0.6 : 1,
      }}
    >
      {togglingOrderPhoto ? "…" : requireOrderPhoto ? "Mandatory" : "Optional"}
    </button>
  </div>
  <div style={{ borderTop: "1px solid #e5e7eb", margin: "12px 0" }} />

<div style={s.settingRow}>
  <div style={s.settingInfo}>
    <div style={s.settingLabel}>Max photos per item</div>
    <div style={s.settingDesc}>
      How many photos a user can take per item and for the full order. Between 1 and 20.
    </div>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <input
      type="number"
      min={1}
      max={20}
      value={maxPhotosPerItem}
      onChange={e => setMaxPhotosPerItem(Number(e.target.value))}
      style={{ ...s.input, width: 64, textAlign: 'center' }}
    />
    <button
      onClick={handleSaveMaxPhotos}
      disabled={savingMaxPhotos}
      style={{ ...s.addBtn, whiteSpace: 'nowrap' }}
    >
      {savingMaxPhotos ? 'Saving…' : 'Save'}
    </button>
  </div>
</div>
</Section>
              <Section title="Box / Set Type">
  <div style={s.settingRow}>
    <div style={s.settingInfo}>
      <div style={s.settingLabel}>Unit grouping label</div>
      <div style={s.settingDesc}>
        Choose the term your warehouse uses for grouped quantities. 
        This must match your Striven custom field name (e.g. "Carton Size", "Lot Size", "Pallet Size").
      </div>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <select
        value={setLabel}
        onChange={e => setSetLabel(e.target.value)}
        style={{ ...s.select, fontSize: 14, padding: '6px 10px' }}
      >
<option value="Carton Size">Carton Size</option>
<option value="Lot Size">Lot Size</option>
<option value="Pallet Size">Pallet Size</option>
<option value="Box Size">Box Size</option>
<option value="Case Size">Case Size</option>
<option value="Pack Size">Pack Size</option>
<option value="Batch Size">Batch Size</option>
      </select>
      <button
        onClick={handleSaveSetLabel}
        disabled={savingLabel}
        style={{ ...s.addBtn, whiteSpace: 'nowrap' }}
      >
        {savingLabel ? 'Saving…' : 'Save'}
      </button>
    </div>
  </div>
</Section>
<Section title="PDF Quality">
  <div style={s.settingRow}>
    <div style={s.settingInfo}>
      <div style={s.settingLabel}>Image resolution</div>
      <div style={s.settingDesc}>
        Controls photo quality in generated PDFs. Lower = smaller files, faster uploads.
        High: ~1800px / Medium: ~1200px / Low: ~600px.
      </div>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <select
        value={pdfResolution}
        onChange={e => setPdfResolution(e.target.value)}
        style={{ ...s.select, fontSize: 14, padding: '6px 10px' }}
      >
        <option value="low">Low</option>
        <option value="medium">Medium</option>
        <option value="high">High</option>
      </select>
      <button
        onClick={handleSavePdfResolution}
        disabled={savingResolution}
        style={{ ...s.addBtn, whiteSpace: 'nowrap' }}
      >
        {savingResolution ? 'Saving…' : 'Save'}
      </button>
    </div>
  </div>
</Section>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={s.section}>
      <div style={s.sectionTitle}>{title}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {children}
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", placeholder }) {
  return (
    <div>
      <label style={s.label}>{label}</label>
      <input style={s.input} type={type} value={value} placeholder={placeholder || ""}
        onChange={e => onChange(e.target.value)} />
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 48 48" style={{ marginRight: 6, verticalAlign: "middle" }}>
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  );
}

const s = {
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
  panel: { background: "#fff", borderRadius: 12, width: 680, maxHeight: "88vh", display: "flex", flexDirection: "column", boxShadow: "0 8px 40px rgba(0,0,0,0.18)", overflow: "hidden" },
  header: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "20px 24px", borderBottom: "1px solid #eee" },
  headerTitle: { margin: 0, fontSize: 18, fontWeight: 700 },
  closeBtn: { background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#888", lineHeight: 1 },
  tabs: { display: "flex", borderBottom: "1px solid #eee", padding: "0 24px" },
  tab: { padding: "12px 20px", border: "none", background: "none", cursor: "pointer", fontSize: 14, color: "#666", borderBottom: "2px solid transparent", marginBottom: -1 },
  tabActive: { color: "#0078d4", borderBottom: "2px solid #0078d4", fontWeight: 600 },
  body: { overflowY: "auto", padding: 24, flex: 1 },
  addUserRow: { display: "flex", gap: 10, marginBottom: 20 },
  input: { flex: 1, padding: "8px 12px", border: "1px solid #ddd", borderRadius: 6, fontSize: 14, width: "100%", boxSizing: "border-box" },
  addBtn: { padding: "8px 18px", background: "#0078d4", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 14, whiteSpace: "nowrap" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { textAlign: "left", padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#888", textTransform: "uppercase", borderBottom: "2px solid #eee" },
  tr: { borderBottom: "1px solid #f0f0f0" },
  td: { padding: "10px 12px", fontSize: 14 },
  youBadge: { fontSize: 13, color: "#666" },
  logoutBtn: { padding: "6px 14px", background: "#fff", border: "1px solid #ddd", borderRadius: 6, cursor: "pointer", fontSize: 13, color: "#dc2626" },
  select: { padding: "4px 8px", border: "1px solid #ddd", borderRadius: 4, fontSize: 13 },
  deleteBtn: { padding: "4px 12px", background: "#fff", border: "1px solid #fca5a5", color: "#dc2626", borderRadius: 4, cursor: "pointer", fontSize: 13 },
  section: { background: "#f9fafb", borderRadius: 8, padding: 18, border: "1px solid #eee" },
  sectionTitle: { fontWeight: 700, fontSize: 14, marginBottom: 14, color: "#333" },
  label: { display: "block", fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4 },
  saveBtn: { padding: "10px 24px", background: "#0078d4", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 14, alignSelf: "flex-end" },
  reconnectBox: { display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", border: "1px solid #ddd", borderRadius: 6, padding: "12px 14px", marginTop: 4 },
  reconnectBtn: { display: "flex", alignItems: "center", padding: "7px 14px", background: "#fff", border: "1px solid #ccc", borderRadius: 6, cursor: "pointer", fontSize: 13, whiteSpace: "nowrap" },
  settingRow: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 },
  settingInfo: { flex: 1 },
  settingLabel: { fontWeight: 600, fontSize: 14, color: "#111" },
  settingDesc: { fontSize: 12, color: "#666", marginTop: 3, lineHeight: 1.5 },
  toggleBtn: { padding: "7px 20px", borderRadius: 20, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 700, minWidth: 52, transition: "background 0.2s" },userRow: {
  display: 'flex', alignItems: 'center', gap: 14,
  padding: '14px 16px', borderRadius: 8,
  border: '1px solid #f0f0f0', background: '#fff',
  marginBottom: 6, transition: 'background 0.15s',
}, grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
avatar: {
  width: 40, height: 40, borderRadius: '50%',
  background: '#dbeafe', color: '#1e40af',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontWeight: 700, fontSize: 16, flexShrink: 0,
},
rolePill: {
  display: 'inline-block', padding: '4px 14px',
  borderRadius: 20, fontSize: 13, fontWeight: 600,
  border: '1px solid #d1fae5', background: '#f0fdf4', color: '#166534',
},
rolePillAdmin: {
  background: '#166534', color: '#fff', border: 'none',
},
roleSelect: {
  padding: '5px 10px', borderRadius: 20,
  border: '1px solid #d1d5db', fontSize: 13,
  background: '#f9fafb', cursor: 'pointer',
},
};

export default AdminPanel;